import { ShowFn, useModal } from "mui-modal-provider";
import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar } from "notistack";
import { createContext } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { FrmErrorProps } from "../../uni-questionnaire/pages/FrmError";

/*
 * 注意! 有依賴 notistack 的 Provider
 * 且 <SnackbarProvider 必須是 AppContext 的上層元件
 * 
 * 這個 Dialog範例，可能可以修正此問題，改天再來研究
 * https://stackoverflow.com/questions/63737526/mui-how-to-open-dialog-imperatively-programmatically
 * 
 * <SnackbarProvider maxSnack={3}>
 *   <App/>
 * </SnackbarProvider>
 * 
 * App()=>{
 *    var app_context_methods = useAppContext();
 * 
 *    return (
 *      <AppContext.Provider value={app_context_methods}>
 *          ...
 *      </AppContext.Provider>
 *    )
 * }
 */
export type AppContextProps = {    
  ShowToast: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey;
  ShowDialog: ShowFn;
  Navigate: NavigateFunction;
  NavigateToErrorPage: (error_code: string, error_title:string, error_message: string)=>void;
}




export const AppContext = createContext<null | AppContextProps>(null);

export function useAppContext(): AppContextProps {

  const {showModal} = useModal();// 更多方法 updateModal: UpdateFn;、 hideModal: HideFn;、  destroyModal: DestroyFn;

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();
  
  /** 
   * 將某些常用方法統合，看起來像原生 APP 該有的方法   
   * 這些方法通常不直接使用; 如: ctx.ShowToast()、ctx.ShowDialog()...  
   * 而是透過其他 Toast.tsx、MessageDialog.tsx、InputDialog.tsx... 呼叫使用  
   * 如果之後要改變外觀或內部核心，直接抽換掉個別 *.tsx 裡面的寫法  
   * 外部的程式應該不會受到影響  
  */
  const re: AppContextProps = {
    ShowToast: enqueueSnackbar,
    ShowDialog: showModal,
    Navigate: navigate,
    NavigateToErrorPage: NavigateToErrorPage,
  };
  return re;

  function NavigateToErrorPage(error_code: string, error_title:string, error_message: string){
    
    navigate("/error", {
      state: {
        "error_code": error_code,
        "error_title": error_title,
        "error_message": error_message
      } as FrmErrorProps
    });
  }
}
  //------------------------------------------------------------
  /** 
   * Toast 核心
   * - 給 Toast.tsx 呼叫用的 核心方法
   * - 用來呼叫 notistack 原生方法   * 
   */
  // function ShowToast(message: string, options?: notistack.OptionsObject | undefined): notistack.SnackbarKey {
  //   return enqueueSnackbar(message, options);
  // }


